export default "__VITE_ASSET__Mgu2$8oW__"